import { render, staticRenderFns } from "./PlanSettingsChannels.vue?vue&type=template&id=0194bb75"
import script from "./PlanSettingsChannels.vue?vue&type=script&lang=ts"
export * from "./PlanSettingsChannels.vue?vue&type=script&lang=ts"
import style0 from "./PlanSettingsChannels.vue?vue&type=style&index=0&id=0194bb75&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports